import { createSlice } from '@reduxjs/toolkit';

interface SalesOrderLineItemState {
	selectVendorMaterialModalVisible: boolean;
}

const initialState: SalesOrderLineItemState = {
	selectVendorMaterialModalVisible: false,
};

export const salesOrderLineItem = createSlice({
	name: 'salesOrderLineItem',
	initialState,
	reducers: {
		showSelectVendorMaterialModal: (state) => {
			state.selectVendorMaterialModalVisible = true;
		},
		closeSelectVendorMaterialModal: (state) => {
			state.selectVendorMaterialModalVisible = false;
		},
	},
});

// Action creators are generated for each case reducer function
export const { showSelectVendorMaterialModal, closeSelectVendorMaterialModal } =
	salesOrderLineItem.actions;

export default salesOrderLineItem.reducer;
